import { Button, Checkbox, DatePicker, Input, Select } from "@arco-design/web-react";
import { RotateCcw, Search } from "lucide-react";

import { FINANCE_PAYABLE_REQUEST_STATUS_OPTIONS } from "../service";
import type { FinancePayableOverviewFilters, FinancePayableRequestStatus } from "../types";
import "../../../shared/ui/crmListPageLayout.css";
import "./financeOverview.css";

type Props = {
  filters: FinancePayableOverviewFilters;
  onChange: (filters: FinancePayableOverviewFilters) => void;
  onSearch: () => void;
  onReset: () => void;
};

/** 应付列表筛选区：搜索（含结算主体）、出团日期范围（两端都含）、计调姓名、请款状态、只看还有可请额度；点查询才生效。 */
export function FinancePayableOverviewFilterCard({ filters, onChange, onSearch, onReset }: Props) {
  return (
    <section className="crm-list-filter-panel" role="search" aria-label="应付列表筛选" data-layout="two-tier-responsive">
      <form
        className="crm-list-filter-fields"
        onSubmit={(event) => {
          event.preventDefault();
          onSearch();
        }}
      >
        <div className="crm-list-filter-primary">
          <label className="crm-list-field crm-list-field--lg">
            <span>搜索</span>
            <Input
              value={filters.keyword}
              placeholder="团编码、订单号、线路、结算主体"
              allowClear
              onPressEnter={onSearch}
              onChange={(keyword) => onChange({ ...filters, keyword })}
            />
          </label>
          <div className="crm-list-field crm-list-field--lg">
            <span>出团日期</span>
            <DatePicker.RangePicker
              className="finance-overview-date-range"
              placeholder={["出团开始日期", "出团结束日期"]}
              value={filters.departureFrom && filters.departureTo ? [filters.departureFrom, filters.departureTo] : undefined}
              getPopupContainer={() => document.body}
              onChange={(dates) =>
                onChange({ ...filters, departureFrom: dates?.[0] || null, departureTo: dates?.[1] || null })
              }
            />
          </div>
          <label className="crm-list-field crm-list-field--md">
            <span>计调</span>
            <Input
              value={filters.dispatcherName}
              placeholder="计调姓名"
              allowClear
              onPressEnter={onSearch}
              onChange={(dispatcherName) => onChange({ ...filters, dispatcherName })}
            />
          </label>
          <div className="crm-list-field crm-list-field--md">
            <span>请款状态</span>
            <Select
              aria-label="请款状态"
              placeholder="全部"
              allowClear
              value={filters.requestStatus ?? undefined}
              getPopupContainer={() => document.body}
              options={[...FINANCE_PAYABLE_REQUEST_STATUS_OPTIONS]}
              onChange={(requestStatus?: FinancePayableRequestStatus) =>
                onChange({ ...filters, requestStatus: requestStatus ?? null })
              }
            />
          </div>
          <div className="crm-list-field crm-list-field--md">
            <span>可请额度</span>
            <Checkbox
              className="finance-overview-check"
              checked={filters.hasRequestableAmount}
              onChange={(hasRequestableAmount: boolean) => onChange({ ...filters, hasRequestableAmount })}
            >
              只看还有可请额度
            </Checkbox>
          </div>
        </div>
      </form>
      <div className="crm-list-filter-actions">
        <Button icon={<RotateCcw size={16} />} onClick={onReset}>
          重置
        </Button>
        <Button type="primary" icon={<Search size={16} />} onClick={onSearch}>
          查询
        </Button>
      </div>
    </section>
  );
}
